export const EI = {
  module: 'EI',
  baseUrl: '/app/experience-insights',
  parentBaseSuffix: 'experience_insights',
};

export const AI = {
  module: 'AI',
  baseUrl: '/app/ad-insights',
  parentBaseSuffix: 'ad_insights',
};

export const APP = {
  module: 'APP',
  baseUrl: '/app/app-insights',
  parentBaseSuffix: 'app_insights',
};

export const ODP = {
  module: 'ODP',
  baseUrl: '/app/odp',
  parentBaseSuffix: 'odp',
};

export const BASE = {
  module: 'BASE',
  baseUrl: '/app',
  parentBaseSuffix: 'base',
};
